<script>
    
    export let date 
    let type = "short"
    
    let d_ = ""
    
     function dateToShortString(d) {
        const date = new Date(d);
        const options = { day: '2-digit', month: 'short', year: 'numeric' };
        return date.toLocaleDateString('en-GB', options).replace(/ /g, ' ');

    }



    const d_c2 = (date)=>{
        let d = null;
        d = new Date(date*1000);
        if (d !== null) {
            d_ = dateToShortString(d);
        }

    }

    $:if(typeof date === "string")
        d_= dateToShortString(date) 
    else 
        d_c2(date)
</script>

{d_}